import axios from "axios";
import { useEffect, useState } from "react";
// Baguhin ang mga sumusunod na path kung hindi ito tama sa iyong file structure:
import axiosInstant from "../../../axiosInstant";
import { decodeId } from "../../../hash";

export default function LotData(
  page,
  auctionID,
  search,
  set_id,
  searchCat,
  favorite,
  refreshTrigger
) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [lotdata, setLot] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [totalLOts, setTotalLots] = useState(0);


  // --- MAIN FETCH DATA LOGIC ---
  useEffect(() => {
    // Huwag mag-fetch kung wala pang Auction ID
    if (!auctionID) return;
    
    // --- LOHIKA NG PAG-RESET (Kung nagbago ang filter, i-reset ang listahan) ---
    // Kung ang page ay 1 (ibig sabihin, may bagong filter or initial load), i-reset ang listahan.
    if (page === 1) {
      setLot([]);
      setTotalLots(0);
    }

    setLoading(true);
    setError(false);
    setErrorMsg("");

    let cancel;
    
    // Construct the API URL
    const url = `lot?auction_id=${auctionID ? decodeId(auctionID) : ""}&search=${
        search || ""
      }&set_id=${set_id || ""}&page=${page || 1}&cat=${searchCat || ""}&fav=${
        favorite || ""
      }`;


    axiosInstant({
      method: "GET",
      url: url,
      cancelToken: new axios.CancelToken((c) => (cancel = c)),
    })
      .then((res) => {
        if (res.data.status === true && res.data.msg) {
          setTotalLots(res.data.count);
          const newLots = res.data.msg;
          
          setLot((prevlotdata) => {
            const lotMap = new Map(
                prevlotdata.map(lot => [lot.data.lot_number, lot])
            );
            
            newLots.forEach(lot => {
                // Tiyakin na ang `fav` status ay nakuha mula sa API, hindi sa lumang UI state
                lotMap.set(lot.data.lot_number, lot);
            });
            
            return Array.from(lotMap.values());
          });
          
          setHasMore(res.data.msg.length > 0);
          setErrorMsg("");

        } else {
          setErrorMsg(res.data.msg || "No lots found.");
          setHasMore(false);
          if (page === 1) {
             setLot([]); // Clear data kung walang lots
          }
        }
        setLoading(false);
      })
      .catch((e) => {
        if (axios.isCancel(e)) return;

        setLoading(false);
        setError(true);
        if (e.response && e.response.data) {
          setErrorMsg(e.response.data.msg || "Server error.");
        } else {
          setErrorMsg("Network error or server is unreachable.");
        }
        setHasMore(false);
        if (page === 1) {
          setLot([]); // Clear data kung error sa page 1
        }
      });

    // Dependencies: Lahat ng arguments ay kailangan para mag-trigger ng re-fetch
    return () => cancel();
  
  }, [
    page, auctionID, search, set_id, searchCat, favorite, refreshTrigger
  ]);

  return { loading, error, lotdata, hasMore, errorMsg, totalLOts, setLot };
  
}